<template>
  <div class="login_info">
    <!-- 关闭按钮 -->
    <div class="close" @click="clickClose">
      <van-icon name="cross" />
    </div>
    <!-- <pcHeader></pcHeader> -->
    <div class="logo">
      <img class="img" src="../../../../../static/image/index2.png" alt="" />
    </div>
    <div class="login_title">
      <span :class="passwordPhone === 0 ? 'active' : ''" @click="phoneWordClick(0)">{{
        $t('message.login.log_phone')
      }}</span>
      <span :class="passwordPhone === 1 ? 'active' : ''" @click="phoneWordClick(1)">{{
        $t('message.login.log_pass')
      }}</span>
    </div>

    <VuePhoneNumberInput
      v-model="phone"
      @update="validate"
      :translations="translations"
      class="phoneNumber"
      :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
    />
    <div class="login_info_input" v-if="passwordPhone === 0">
      <van-form ref="form">
        <!-- <van-field
          v-model="phoneInfo.mobile"
          type="number"
          label="+86"
          :placeholder="$t('message.login.please_phone')"
          show-word-limit
          :rules="telRules"
        /> -->
        <!-- 请输入验证码 -->
        <van-field
          class="sms"
          v-model="phoneInfo.smsCode"
          center
          :placeholder="$t('message.login.enter_code')"
        >
          <button
            slot="button"
            :disabled="!countdown"
            :class="[countdown ? 'reg_active' : 'reg_disActive']"
            @click="getCode"
            type="text"
          >
            <span v-if="countdown">{{ text }}</span>
            <span v-if="!countdown">{{ text }} ({{ count }})</span>
          </button>
        </van-field>
      </van-form>
    </div>
    <div class="login_info_input" v-if="passwordPhone === 1">
      <van-form ref="form">
        <!-- <van-field
          v-model="queryInfo.mobile"
          type="number"
          label="+86"
          :placeholder="$t('message.login.please_phone')"
          show-word-limit
          :rules="telRules"
        /> -->
        <!-- 输入密码 -->
        <van-field
          autocomplete
          v-model="queryInfo.password"
          type="password"
          :placeholder="$t('message.login.please_pass')"
          :rules="[
            {
              required: true,
              trigger: 'onBlur',
              message: $t('message.login.pass_null')
            },
            {
              pattern: /^.*(?=.{6,18})(?=.*\d)(?=.*[a-z]{1,}).*$/,
              message: $t('message.login.new_pass_null'),
              trigger: 'onBlur'
            }
          ]"
        />
      </van-form>
    </div>

    <div class="bottom">
      <!-- <van-checkbox icon-size="16px" v-model="checked"> 我已阅读并同意使用协议及 </van-checkbox>
      <div class="div">隐私政策</div> -->
    </div>

    <div class="login_phone_btn" v-if="passwordPhone === 0">
      <van-button
        round
        v-if="phoneInfo.mobile == '' || phoneInfo.mobile == undefined || phoneInfo.smsCode == ''"
        disabled
        >{{ $t('message.login.sign') }}</van-button
      >
      <van-button round v-else @click="submitPhone">{{ $t('message.login.sign') }}</van-button>
    </div>

    <div class="login_phone_btn" v-if="passwordPhone === 1">
      <van-button
        round
        v-if="phoneInfo.mobile == '' || phoneInfo.mobile == undefined || queryInfo.password == ''"
        disabled
        >{{ $t('message.login.sign') }}</van-button
      >
      <van-button round v-else @click="submit" v-preventReClick="3000">{{
        $t('message.login.sign')
      }}</van-button>
      <!-- <van-button round v-if="queryInfo.mobile == ''" disabled>{{
        $t('message.login.sign')
      }}</van-button>
      <van-button round v-else @click="submit" v-preventReClick="3000">{{
        $t('message.login.sign')
      }}</van-button> -->
    </div>

    <div class="login_text">
      <span @click="registerClick">{{ $t('message.login.account_reg') }}</span>
      <span class="span" @click="forgetClick">{{ $t('message.login.forget_pass') }}</span>
    </div>

    <div class="bottom">
      <van-checkbox style="font-size: 12px" icon-size="16px" v-model="checked">
        {{ $t('message.login.agree_read') }}
      </van-checkbox>
      <div class="div" @click="privacy">{{ $t('message.login.privacy') }}</div>
    </div>
    <van-popup
      :closeable="true"
      :close-on-click-overlay="false"
      :get-container="getContainer"
      v-model="showTxt"
      class="text_pop"
    >
      <user-text-pop />
    </van-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'vue-tel-input/dist/vue-tel-input.css'
import { setCookie, clearCookie } from '@/utils/cookie'
import { login, getSms, loginSms } from '@/api/login'
import { Toast } from 'vant'
import UserTextPop from '../../components/UserTextPop.vue'
const defaultQuery = Object.freeze({
  mobile: '',
  password: ''
})
const defaultPhone = Object.freeze({
  mobile: '',
  smsCode: ''
})
// import pcHeader from '@/components/pcHeader'
export default {
  name: 'LoginInfo',
  data() {
    return {
      countdown: true,
      count: '',
      timer: null,
      text: this.$t('message.login.send_code'),
      error: false, //校验
      phone: '',
      showTxt: false,
      form: {
        mobile: {
          callingCode: '86',
          phoneNumber: '18611112222'
        }
      },
      passwordPhone: 0,
      queryInfo: { ...defaultQuery },
      phoneInfo: { ...defaultPhone },
      checked: true,
      telRules: [
        {
          required: true,
          message: this.$t('message.login.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /0?(13|14|15|17|18|19)[0-9]{9}/.test(value)
          },
          message: this.$t('message.login.correct_phone'),
          trigger: 'onBlur'
        }
      ],
      translations: {
        // countrySelectorLabel: '中国',
        // countrySelectorError: '请选择国家',
        // phoneNumberLabel: '手机号码',
        // example: '示例 :'
      }
    }
  },
  components: {
    // VuePhoneNumberInput
    VuePhoneNumberInput,

    UserTextPop
    // VueTelInput
  },
  created() {
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
  },
  methods: {
    // 点击关闭
    clickClose() {
      this.$emit('clickClose')
    },
    privacy() {
      this.showTxt = true
    },
    async getCode() {
      const TIME_COUNT = 60
      if (
        this.phoneInfo.mobile == '' ||
        this.phoneInfo.mobile == undefined ||
        this.phoneInfo.mobile == 'undefined'
      ) {
        Toast.fail(this.$t('message.login.please_phone'))
      } else {
        if (!this.timer) {
          this.count = TIME_COUNT
          this.countdown = false
          this.text = this.$t('message.login.resend')
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.countdown = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        const { data: res } = await getSms({ phone: this.phoneInfo.mobile })
        if (res.resultCode === 200) {
          Toast.success(this.$t('message.login.sent_succ'))
        } else {
          Toast.fail(this.$t('message.login.failed_send'))
        }
      }
    },
    // 返回弹窗的挂在节点
    getContainer() {
      return document.querySelector('.login_info')
    },
    validate(val) {
      // console.log(val)
      this.phoneInfo.mobile = val.formattedNumber
      this.queryInfo.mobile = val.formattedNumber
    },
    phoneWordClick(index) {
      this.passwordPhone = index
    },

    async submitPhone() {
      if (this.phoneInfo.smsCode === '') {
        Toast.fail(this.$t('message.login.enter_code'))
      } else {
        const { data: res } = await loginSms(this.phoneInfo)
        if (res.resultCode === 200) {
          this.$toast({
            duration: 1000,
            message: this.$t('message.login.login_suc')
          })
          sessionStorage.setItem('token', res.data.token)
          sessionStorage.setItem('userId', res.data.apiUser.id)
          sessionStorage.setItem('phone', res.data.apiUser.phone)
          sessionStorage.setItem('userName', res.data.apiUser.nickName)
          setCookie('userId', res.data.apiUser.id, 60)
          setCookie('token', res.data.token, 60)
          setTimeout(() => {
            this.$toast({
              duration: 1000,
              message: this.$t('message.login.page_jump')
            })
            this.$router.go(0)
          }, 1000)
          setTimeout(() => {
            console.log(this.$router)
          }, 2000)
        } else {
          this.$toast.fail(res.message)
          clearCookie('token')
        }
      }
    },
    async submitClick() {
      const { data: res } = await login(this.queryInfo)
      if (res.resultCode === 200) {
        this.$toast({
          duration: 1000,
          message: this.$t('message.login.login_suc')
        })
        sessionStorage.setItem('token', res.data.token)
        sessionStorage.setItem('userId', res.data.apiUser.id)
        sessionStorage.setItem('phone', res.data.apiUser.phone)
        sessionStorage.setItem('userName', res.data.apiUser.nickName)
        setCookie('userId', res.data.apiUser.id, 60)
        setCookie('token', res.data.token, 60)
        setTimeout(() => {
          this.$toast({
            duration: 1000,
            message: this.$t('message.login.page_jump')
          })
        }, 1000)
        setTimeout(() => {
          this.$router.go(0)
        }, 2000)
      } else {
        this.$toast.fail(res.message)
        clearCookie('token')
        clearCookie('userId')
      }
    },
    submit() {
      if (this.checked) {
        this.$refs.form
          .validate()
          .then(() => {
            this.submitClick()
          })
          .catch(() => {
            this.$toast.fail(this.$t('message.login.please_com'))
          })
      } else {
        this.$toast.fail(this.$t('message.login.check_agree'))
      }
    },
    registerClick() {
      // this.$router.push({
      //   name: 'registerInfo'
      // })
      this.$emit('registerInfo')
    },
    forgetClick() {
      this.$emit('forgetClick')
      // this.$router.push({
      //   name: 'ForGetPassword'
      // })
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes loginInfo {
  0% {
    transform: scale(0.3);
    opacity: 0.3;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.login_info {
  width: 100%;
  // height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
  // padding: 0 16px;
  overflow: hidden;
  text-align: center;
  border-radius: 8px;
  // animation: loginInfo .5s ease-in-out;
  position: relative;
  /deep/.van-overlay {
    border-radius: 8px;
  }

  .close {
    width: 25px;
    height: 25px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .phoneNumber {
    width: 300px;
    margin: 0 auto;
  }
  .vue-phone-number-input {
    /deep/.input-tel__input {
      border: 0;
      border-top-right-radius: 20px !important;
      border-bottom-right-radius: 20px !important;
      border-right: 0px solid #fff;
      background-color: #f6f6f6;
      height: 46px;
      min-height: 46px;
    }
    /deep/.country-selector__input {
      border: 0;
      border-top-left-radius: 20px !important;
      border-bottom-left-radius: 20px !important;
      border-right: 0px solid #fff;
      background-color: #f6f6f6;
      height: 46px;
      min-height: 46px;
      padding-top: 0;
      padding-left: 50px;
    }
    /deep/.input-tel {
      height: 46px;
      min-height: 46px;
    }
    /deep/.country-selector {
      height: 46px;
      min-height: 46px;
    }
    /deep/.country-selector__label {
      display: none;
    }
    /deep/.country-selector__country-flag {
      top: 50%;
      left: 25%;
      transform: translate(-50%, -50%);
    }
  }

  .logo {
    width: 100%;
    margin-top: 63px;
    .img {
      width: 52px;
      height: 37px;
    }
  }
  .sms {
    button {
      background: none;
      border: none;
    }

    .reg_active {
      color: #3562ff;
      cursor: pointer;
    }

    .reg_disActive {
      color: #999;
      cursor: pointer;
    }
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }

  .login_title {
    // width: 100%;
    display: inline-block;
    width: 343px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 15px 0;
    margin: 15px 0;
    border-bottom: 1px solid #efefef;
    text-align: center;

    span {
      color: #999999;
      font-weight: 400;
      font-size: 16px;
      box-sizing: border-box;
      padding: 0 20px;
      cursor: pointer;
    }

    .active {
      color: #1a1a1a;
      font-weight: 500;
      font-size: 20px;
    }
  }

  .numberInput {
    width: 300px;
    margin: 0 auto;
    // position: absolute;
    // left: 50%;
  }
  .login_info_input {
    width: 100%;
    overflow: hidden;
    // position: relative;
    .van-cell {
      margin: 20px auto 0 auto;
      width: 300px;
      background-color: #f6f6f6;
      border-radius: 32px;

      /deep/.van-field__label {
        width: 40px;
        text-align: center;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    display: flex;
    margin: 24px auto;
    text-align: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    text-align: center;

    /deep/ .van-checkbox__label {
      color: #999999;
      font-size: 12px;
      font-weight: 400;
    }

    .div {
      color: #3562ff;
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
      margin-left: 2px;
      cursor: pointer;
    }
  }

  .login_phone_btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .van-button {
      width: 300px;
      height: 42px;
      box-sizing: border-box;
      text-align: center;
      border: none;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      background: #3562ff;
    }

    /deep/ .van-button--disabled {
      color: #999999;
      background: #ededed;
    }
  }

  .login_text {
    width: 100%;
    overflow: hidden;
    margin: 15px auto;
    width: 300px;
    text-align: right;

    span {
      color: #359eff;
      font-size: 12px;
      font-weight: 400;
      cursor: pointer;
    }

    .span {
      text-decoration: underline;
      color: #999;
      margin-left: 40px;
      cursor: pointer;
    }
  }
}

.text_pop {
  width: 90%;
  height: 80%;
  border-radius: 12px;
}
</style>
